export default "__VITE_ASSET__DFj0fchb__"